import { useQuery } from "@tanstack/react-query";
import stationsService from "services/admin/stationsService";

export const useGetStations = (queryParams = {}) => {
  return useQuery({
    queryKey: ["stations", queryParams],
    queryFn: async () => {
      const response = await stationsService.getAll(queryParams);
      return response.data;
    },
  });
};
